/**
 * Where the chat is the page (Justin, 2026-10-30): `/cinch-ai` and `/cinch-ai/<thread id>`. There the
 * Cinch AI page is Full screen, so the docked panel, bubble and window are hidden. Settings, Memories,
 * Automations, Shared chats and folders are Cinch AI routes too, but not the chat, so the docked panel
 * stays (the Integrations entry for the Cinch AI app opens `/cinch-ai/settings`).
 */
const NOT_CHAT = new Set(['settings', 'memories', 'automations', 'shared', 'folders']);

/** The window's "Full screen" opens the Cinch AI page with this query: the history column starts collapsed. */
export const FULL_SCREEN_QUERY = '?nav=collapsed';

/** sessionStorage key: where the page's "Exit full screen" goes back to, saved by the window's "Full screen". */
export const FULL_SCREEN_RETURN_KEY = 'cinch.ai.fullscreenReturn';

/** The public page of a shared chat (CINCHAI-113), outside sign-in. */
export const sharedChatPath = token => `/ai/shared/${token}`;
export const sharedChatUrl = token => `${window.location.origin}${sharedChatPath(token)}`;
export function isCinchAiChatPath(pathname) {
  const match = /^\/cinch-ai(?:\/([^/]+))?\/?$/.exec(pathname || '');
  return !!match && !NOT_CHAT.has(match[1]);
}

/**
 * The in-app route a link in a reply points to, or null for an external link (Justin, 2026-10-30): a
 * reply names the record it changed with a link like `/segments/<id>/edit`, and that link goes through
 * the app router in the same tab. A root-relative path, or a full URL on the app's own origin, is
 * in-app; anything else (another site, `//host`, mailto:) opens in a new tab.
 */
export function inAppPath(href, origin) {
  if (typeof href !== 'string' || !href) return null;
  if (href.startsWith('/')) return href.startsWith('//') || href.startsWith('/\\') ? null : href;
  if (!origin) return null;
  try {
    const url = new URL(href);
    return url.origin === origin ? `${url.pathname}${url.search}${url.hash}` : null;
  } catch (e) {
    return null;
  }
}